import styled from "styled-components";

export const FormRowWrapper = styled.div`
  display: flex;
`;
